<template>
  <Snackbar
    v-if="!$i18n.g1"
    ref="snackbar"
    :oneTimeOnly="true"
    :localKey="localKey"
    class="snckbr_bottom-center d-flex drag-noevents"
    style="
      --position: fixed;
      --clr-back: var(--clr-primary-1);
      --close-inset: 0.5rem 0.25rem auto auto;
      gap: 1rem;
      padding: 0.5rem 1rem;
      z-index: 100;
      min-width: clamp(6rem, 24rem, calc(100vw - 2rem));
    "
  >
    <a
      class="f-center"
      style="min-width: 0"
      target="_blank"
      :href="link"
      @click="$refs.snackbar.close()"
    >
      <i class="mdi clr-white text-large mdi-book-information-variant mr-3"></i>
      <div class="truncate clr-white">
        <span
          class="clr-white text-normal-large weight_500 mr-auto pr-6"
          v-html="text"
        />
      </div>
    </a>
  </Snackbar>
</template>

<script>
import Snackbar from '@/components/Messages/Snackbar'

export default {
  name: 'SnackbarLinkGuide',
  components: {
    Snackbar,
  },
  props: {
    localKey: { type: String, required: true },
    link: { type: String, required: true },
    text: { type: String, required: true },
  },
}
</script>
